// @flow
import { connect } from 'react-redux';
import type { State, Actions } from '../store';
import Channels from '../components/Channels';
import {
  selectors as permissionSelectors,
  actions as permissionActions
} from '../store/permissions';

const mapStateToProps = ({ permissionReducer }: State, { match }) => ({
  permission: permissionSelectors.selectPermissionById(
    permissionReducer,
    match.params.permId
  ),
  channels: permissionSelectors.selectUserPermissionChannels(
    permissionReducer,
    match.params.permId
  ),
  product: permissionSelectors.selectPermissionById(
    permissionReducer,
    match.params.prodId
  ),
  userPermission: permissionSelectors.selectUserPermissionByPermissionId(permissionReducer, match.params.permId),
  channelError: permissionReducer.channelError,
  isFetching: permissionReducer.isFetching,
  isChannelPosting: permissionReducer.isChannelPosting
});
const mapDispatchToProps = (dispatch: Dispatch<Actions>, { userId }) => ({
  fetchPermissions: () => dispatch(permissionActions.fetchPermissions(userId)),
  setChannel: (permission, channel, value, userPermission) => dispatch(permissionActions.setChannel(permission, channel, value, userPermission))
});
const ChannelContainer = connect(mapStateToProps, mapDispatchToProps)(Channels);

export default ChannelContainer;
